module.exports = __webpack_public_path__ + "static/media/deezer.7a07ba10.png";